const initializeBlemCinematicVideos = (scope = document) => {
  scope.querySelectorAll('[data-blem-cinematic-hero] video').forEach((video) => {
    if (video.dataset.blemAutoplayReady === 'true') return;
    video.dataset.blemAutoplayReady = 'true';

    const playVideo = () => {
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      const playAttempt = video.play();
      if (playAttempt?.catch) playAttempt.catch(() => {});
    };

    playVideo();
    video.addEventListener('loadedmetadata', playVideo, { once: true });
    video.addEventListener('canplay', playVideo, { once: true });
    window.addEventListener('pageshow', playVideo);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) playVideo();
    });
    document.addEventListener('touchstart', playVideo, { once: true, passive: true });
  });
};

initializeBlemCinematicVideos();
document.addEventListener('DOMContentLoaded', () => initializeBlemCinematicVideos());
document.addEventListener('shopify:section:load', (event) => initializeBlemCinematicVideos(event.target));
